import { Component } from 'react'
import EditEventFormTypeWrapper from "./EditEventFormTypeWrapper";
import TextValueField from "../general/TextValueField";
import getInputTypeFormName from "../func/getInputTypeFormName";
import { ErrorMessage } from "formik";

class EditEventFormInputType extends Component {
    constructor(props) {
        super(props);

        this.state = {
            edit: false,
        };

        this.setEdit = this.setEdit.bind(this);
    }

    setEdit(edit) {
        this.setState({
            edit: edit,
        });
    }

    render() {
        const { headline, arrayOfIds, settings, formValues, currValues, activeField, setActiveField } = this.props;

        return (
            <EditEventFormTypeWrapper headline={headline}>
                {arrayOfIds.map((id) => (
                    <div className="pm-content-info" key={id}>
                        <span className="text-small-regular">
                            {settings[id].form_layout_field_label + ": "}
                        </span>

                        <TextValueField
                                    name={getInputTypeFormName(settings[id].form_layout_field_id)}
                                    type={settings[id].form_layout_field_type}
                                    withLineBreak={false}
                                    lineBreakInCurrentName={false}
                                    formValue={formValues[id]}
                                    currValue={currValues[id]}
                                    activeField={activeField}
                                    setActiveField={setActiveField}
                                />

                        <ErrorMessage className="text-regular-color validation-error" name={getInputTypeFormName(settings[id].form_layout_field_id)} component="div" />
                    </div>
                ))}
            </EditEventFormTypeWrapper>
        );
    }
}

export default EditEventFormInputType;
